import type { FallbackProps } from 'react-error-boundary'
import { ErrorState } from '@/components/feedback/ErrorState'

/** Shown when a page throws: the rest of the app (header) stays usable. */
export function AppError({ resetErrorBoundary }: Readonly<FallbackProps>) {
  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <ErrorState
        message="Something went wrong on this page."
        onRetry={resetErrorBoundary}
      />
    </div>
  )
}
